/*
notes
book one = It's elemental
book two = the big book of experiments
book three = the awesome book of edible experiments for kids
book four = kate the chemist: the stem night disaster - links ok
book five = kate the chemist: the great escape - links ok
book six = kate the chemist: penguin problems - links to Dragons Unicorns book
book seven = kate the chemist: birthday blastoff - 
book eight = kate the chemist: the science of slime - 
*/

const BookOneListData = {
    amazon_link: "https://www.amazon.com/Its-Elemental-Hidden-Chemistry-Everything/dp/0778389421",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/its-elemental-kate-biberdorf/1137814283",
    apple_books_link: "https://books.apple.com/us/book/its-elemental/id1513722284?ct=books_it%27s_elemental&ls=1&cc=us&id=1513722284&urlDesc=%2Fits-elemental&ign-itsct=books_box_link&ign-itscg=30200",
    google_books_link: "https://play.google.com/store/books/details/Kate_Biberdorf_It_s_Elemental?id=hMPkDwAAQBAJ",
    kobo_link: "https://www.kobo.com/us/en/ebook/it-s-elemental",
    audible_link: "https://www.audible.com/pd/Its-Elemental-Audiobook/1488210810",
    librofm_link: "https://libro.fm/audiobooks/9781488210815",
    bookpeople_link: "https://www.bookpeople.com/book/9780778389422",
}

const BookTwoListData = {
    amazon_link: "https://www.amazon.com/Kate-Chemist-Big-Book-Experiments/dp/059311616X/ref=sr_1_3?dchild=1&keywords=big+book+of+experiments&qid=1620666891&sr=8-3",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/kate-the-chemist-kate-biberdorf/1134074687",
    apple_books_link: "https://books.apple.com/us/book/kate-the-chemist-the-big-book-of-experiments/id1480994321",
    google_books_link: "https://www.google.com/books/edition/Kate_the_Chemist_The_Big_Book_of_Experim/2yaxDwAAQBAJ?hl=en",
    kobo_link: "https://www.kobo.com/us/en/ebook/kate-the-chemist-the-big-book-of-experiments",
    audible_link: "",
    librofm_link: "",
    bookpeople_link: "https://bookpeople.com/book/9780593116166",
}

const BookThreeListData = {
    amazon_link: "https://www.amazon.com/Kate-Chemist-Awesome-Edible-Experiments/dp/0593116194/ref=sr_1_2?crid=1UEAHA9850D9E&dchild=1&keywords=awesome+book+of+edible+experiments&qid=1620667889&sprefix=awesome+book+of+%2Caps%2C183&sr=8-2",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/kate-the-chemist-kate-biberdorf/1137854762?ean=9780593116197",
    apple_books_link: "https://books.apple.com/us/book/kate-chemist-awesome-book-edible-experiments-for-kids/id1530732674",
    google_books_link: "https://www.google.com/books/edition/Kate_the_Chemist_The_Awesome_Book_of_Edi/q4L7DwAAQBAJ?hl=en",
    kobo_link: "https://www.kobo.com/us/en/ebook/kate-the-chemist-the-awesome-book-of-edible-experiments-for-kids",
    audible_link: "",
    librofm_link: "",
    bookpeople_link: "https://www.bookpeople.com/book/9780593116197",
}

const BookFourListData = {
    amazon_link: "https://www.amazon.com/gp/product/0593116615?ref_=dbs_m_mng_rwt_calw_thcv_2&storeType=ebooks",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/the-stem-night-disaster-kate-biberdorf/1136847735?ean=9780593116616",
    apple_books_link: "https://books.apple.com/ca/book/the-stem-night-disaster/id1507669071",
    google_books_link: "https://www.google.com/books/edition/The_STEM_Night_Disaster/Pu8OEAAAQBAJ?hl=en&sa=X&ved=2ahUKEwiJ4seC2L_wAhUNKK0KHdQ0CdwQiKUDMBh6BAgCEAQ",
    kobo_link: "https://www.kobo.com/us/en/ebook/the-stem-night-disaster-1",
    audible_link: "https://www.audible.com/pd/The-STEM-Night-Disaster-Audiobook/0593340698?plink=ZvZw2RHsD3dOh1Pm&ref=a_pd_The-Gr_c5_adblp13npsbx_1_2&pf_rd_p=84f8cf28-a842-4761-accd-e5126124c7a3&pf_rd_r=JZP4S4FKPJ4QD25P81WV",
    librofm_link: "https://libro.fm/audiobooks/9780593340691-the-stem-night-disaster",
    bookpeople_link: "https://www.bookpeople.com/book/9780593116616",
}

const BookFiveListData = {
    amazon_link: "https://www.amazon.com/Great-Escape-Kate-Chemist/dp/0593116585/ref=sr_1_1?dchild=1&keywords=the+great+escape+kate+the+chemist&qid=1620669115&sr=8-1",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/the-great-escape-kate-biberdorf/1135714235?ean=9780593116586",
    apple_books_link: "https://books.apple.com/ca/book/the-great-escape/id1494630921",
    google_books_link: "https://www.google.com/books/edition/The_Great_Escape/ZzPGDwAAQBAJ?hl=en&gbpv=0",
    kobo_link: "https://www.kobo.com/us/en/ebook/the-great-escape-38",
    audible_link: "https://www.audible.com/pd/The-Great-Escape-Audiobook/0593287886?plink=BPnyyiR76kLdeXxq&ref=a_pd_Dragon_c5_adblp13npsbx_1_1&pf_rd_p=84f8cf28-a842-4761-accd-e5126124c7a3&pf_rd_r=D1JN3T51B3SSW1ZZCMCG",
    librofm_link: "https://libro.fm/audiobooks/9780593287880-the-great-escape",
    bookpeople_link: "https://www.bookpeople.com/book/9780593116586",
}

const BookSixListData = {
    amazon_link: "https://www.amazon.com/gp/product/0593351274?ref_=dbs_m_mng_rwt_calw_thcv_4&storeType=ebooks",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/some-penguin-problems-kate-biberdorf/1138537104",
    apple_books_link: "https://books.apple.com/us/book/some-penguin-problems/id1547914797",
    google_books_link: "https://www.google.com/books/edition/Some_Penguin_Problems/MWElzgEACAAJ",
    kobo_link: "https://www.kobo.com/us/en/ebook/some-penguin-problems-1",
    audible_link: "https://www.audible.com/pd/Some-Penguin-Problems-Audiobook/0593454634",
    librofm_link: "https://libro.fm/audiobooks/9780593454633-some-penguin-problems",
    bookpeople_link: "https://bookpeople.com/book/9780593351277",
}

const BookSevenListData = {
    amazon_link: "https://www.amazon.com/gp/product/059311664X?ref_=dbs_m_mng_rwt_calw_thcv_3&storeType=ebooks",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/the-birthday-blastoff-kate-biberdorf/1137596646?ean=9780593116647",
    apple_books_link: "https://books.apple.com/ca/book/the-birthday-blastoff/id1530728497",
    google_books_link: "https://www.google.com/books/edition/The_Birthday_Blastoff/nfooEAAAQBAJ?hl=en&sa=X&ved=2ahUKEwinnov02r_wAhUKS6wKHZOsAa0QiKUDMBZ6BAgKEAk",
    kobo_link: "https://www.kobo.com/us/en/ebook/the-birthday-blastoff-1",
    audible_link: "https://www.audible.com/pd/The-Birthday-Blastoff-Audiobook/0593397789?ref=a_author_Ka_c19_lProduct_1_6&pf_rd_p=1ae0e65e-ad09-4aa7-aa73-772cefb1b5e1&pf_rd_r=HA1VDZQG57ZP4EQDZ21Y",
    librofm_link: "https://libro.fm/audiobooks/9780593397787-the-birthday-blastoff",
    bookpeople_link: "https://www.bookpeople.com/book/9780593116647",
}

const BookEightListData = {
    amazon_link: "https://www.amazon.com/Kate-Chemist-Science-Slime/dp/1984822486",
    barnes_and_noble_link: "https://www.barnesandnoble.com/w/kate-the-chemist-the-science-of-slime-kate-biberdorf/1141660565",
    apple_books_link: "https://books.apple.com/us/book/kate-the-chemist-the-science-of-slime/id1556403235",
    google_books_link: "https://books.google.com/books/about/Kate_the_Chemist_The_Science_of_Slime.html?id=NwL9DwAAQBAJ",
    goodreads_link: "https://www.goodreads.com/book/show/57063937-kate-the-chemist-the-science-of-slime",
    kobo_link: "https://www.kobo.com/us/en/ebook/kate-the-chemist-the-science-of-slime",
    audible_link: "https://www.audible.com/pd/Kate-the-Chemist-The-Science-of-Slime-Audiobook/0738578226",
    librofm_link: "https://www.libro.fm/book/kate-the-chemist-the-science-of-slime",
    bookpeople_link: "https://www.bookpeople.com/book/9781984822485",
}

export { BookOneListData, BookTwoListData, BookThreeListData, BookFourListData, BookFiveListData, BookSixListData, BookSevenListData, BookEightListData };